import { VStack } from "apps/commons/components/Stack";
import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import type { SidebarItem } from "libs/codegen/property-onboarding";
import { Fragment, type FunctionComponent } from "react";
import { Separator } from "./Separator";
import { SidebarTitle } from "./Title";
import { sidebarItemStatusMapper } from "./constants";

interface Props {
    items: SidebarItem[];
}

export const SidebarList: FunctionComponent<Props> = ({ items }) => {
    const { pathname } = useDynamicLocation();

    return (
        <VStack gap="4">
            {items.map((item, i) => {
                const transformedItem = {
                    ...item,
                    status: pathname === item.path ? sidebarItemStatusMapper.Active : item.status,
                    previousStepStatus: i !== 0 ? items[i - 1].status : sidebarItemStatusMapper.Active,
                };

                return (
                    <Fragment key={`sidebar-item-${item.order}`}>
                        {i !== 0 && (
                            <Separator
                                active={[transformedItem, items[i - 1]].every(
                                    (o) => o.status !== sidebarItemStatusMapper.Inactive,
                                )}
                            />
                        )}
                        <SidebarTitle {...transformedItem} />
                    </Fragment>
                );
            })}
        </VStack>
    );
};
